import { PublicAccApplyUserStatusRs } from '@domain/rs/acca/v1/test/result/PublicAccApplyUserStatusRs';
import { AnalysisType } from '@domain/constant/analysisType';
import { VersionType } from '@domain/constant/acca/VersionType';

export class PublicAccApplyUserStatusVO {
  name: string;
  schoolName: string;
  majorName: string;
  analysisType: AnalysisType;
  analysisCompletionTime: string;
  version: VersionType;

  constructor(rs: PublicAccApplyUserStatusRs) {
    this.name = rs.name;
    this.schoolName = rs.schoolName;
    this.majorName = rs.majorName;
    this.analysisType = rs.analysisType;
    this.analysisCompletionTime = rs.analysisCompletionTime;
    this.version = rs.version;
  }
}
